import React from 'react';
import '../../styles/Spin.less';

export default function Spin() {
  return (
    <div className="spin__load-wrapper">
      <div className="spin__load">
        <hr />
        <hr />
        <hr />
        <hr />
      </div>
    </div>
  );
}
